import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { spicesData, categoryLabels } from '../data/spicesData';
import { Search, Filter, ChevronRight } from 'lucide-react';

// AI-Generated high-resolution images for spices
const spiceImages = {
  'pepper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bacaa420d54ecd180b568d53bd2aea3f8873489bf9b061609045bfefaa09aad8.png',
  'cardamom': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/52c3a55bace244d3817552b61258569c410fe1b41b18a3d401f0cff4cdc59d03.png',
  'turmeric': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b4f9acf2d3a5e29d42243d3c64259f4d3666d82e61cd28666660865f8c2c1743.png',
  'cumin': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6337f1a59d9898558c0b27f8f71ca2fd169854de1e9e36f4ab325ebc94606448.png',
  'chilli': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cd7bf10b93e367d98fd980623167a68ad1f9fcf58fa8ce62b8e8f113e3db3bd8.png',
  'ginger': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/1dcfe17eb451e705ad21722ca66f204b3271e3e878b0b5893f2f5b08b2aa1d70.png',
  'coriander': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/ef13192878c6bf66a0bf12a872a4dd0a4e7f088ddfd4c62dabf757fb7d6ba083.png',
  'cinnamon': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e5790e42d1fdede6623e596e1bfe9da7c1531596126cb2de92fe127261e49fc8.png',
  'clove': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/0dd77a03fa329223230c2735d92704149f8993f9da4edf7a82ef92bc3b64b109.png',
  'nutmeg': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b9e6d7e4522a21c51889e22dc78ea3b85e5b49cc4d3a1d8d8f1dbd248fb97d63.png',
  'fennel': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/09a68a0c9baef46182bf33a227eef140ceb93d08a77218d2c6319f7161ea2126.png',
  'fenugreek': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6c76ff508c918b83da08c8a8aeca13d5d968a62f48f4d28a1e732b52905acc73.png',
  'mustard': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b8cfa0fcc5228ade5d3ea2bd97b0f318977139dd40a73e7179fbe49b2d52a727.png',
  'saffron': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b4a23db5a4efd82793833dbc7bd64f3a2b6bd5fd0f678ea045b6b92494e11fd4.png',
  'vanilla': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bdc400832b37691624b43c054952b1a02322cd429e352067af9069f7de091200.png',
  'star-anise': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/5f21389f593c7a5b43d1d9d7b46078a24979171ed50ce2b9c167678e4101405a.png',
  'bay-leaf': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/a44330b08c3a25061e34484c333795b28025acef2b23a1115bc911f88048e789.png',
  'asafoetida': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/ecb2724f24b7e1301aabdff3966d242c0362e93940d6a6639f217a84be0e831a.png',
  'tamarind': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/63ae732e7d7abf482e52d9f2511a1439ca8e535068ea7354a51aff974de84809.png',
  'curry-leaf': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/aa442e84982b5462c9dacbc0b19d7fbc0fcec6c0888d6af5b3bc573d2d86d54f.png',
  'garlic': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/eace987d5691cc46e8a49203ccf9b8e91d8f804c76fc486dee6610eda4fc5344.png',
  'poppy-seed': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e8b6a959ecaa1a4e1f0abe8c3af72f5f13bb897e94859002465db96df09eb600.png',
  'caraway': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/749130c7b08968a0f797f9740572057e90844748c3501478f4683b600c2ae795.png',
  'celery': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/6e078f70484569e91fb55105aee52c9c251efb91ab7708ac3132f14b468d2130.png',
  'dill': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3027a533dbfa3a9f84c5c81f33e7dc3c7fc9034e4fb08dc7719a43204f5a9f64.png',
  'sesame': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/088419eda964fc4498d87edafc6778d9670d0a47e43fcbfaaee892268eadfa64.png',
  'ajwain': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/23bd69d4db6601f4febaa7bbd6b621a72d1a96ba2067311b8d15b5d16ad96318.png',
  'nigella': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/b9567efdddc9641c0da289c8b72b015018309eb95c7b0366f524a053feebca92.png',
  'kokum': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/96a7c502009f9536d7d445b97f0457c756cb460aa06c8a130c226d853602f749.png',
  'aniseed': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/50a78fcfe7eea90a892d1f58274dd35d90b19a4f5f37b1b1f4ec27ffec99dc80.png',
  'cardamom-large': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cfb1d0808668198f5b90e9a3c5e01b9582625346d9dcbe5ff1756dddde88edef.png',
  'cassia': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e4808bffbaac36e53531dbfb2493f3c5d7325e4515c6298224d6f9d0e9d41e9b.png',
  'allspice': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3a6679e8509c03696195862be64fc7d8643c7de73162e12dcf772a020a69e8b2.png',
  'basil': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/90580c709132ff0c1269f082dd4e7646adcc03cd8059aee218ddec1782360c88.png',
  'cambodge': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cf6f7bafe5768272524ac0af10c58197f2714e58a87f9316b0077720c5592136.png',
  'caper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/cca33e9dd207fee4683a12f93c8a4e58e561b6b121726d5fcfde49954731e67e.png',
  'galangal': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/8a54797b1b3133c327b7697dd8481500e0f8b0c6666814bd40cab9c6f71c7257.png',
  'horseradish': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/7f7039871f6bc90c4f06e425e919133f1486abf0401b218439655d4346c258f4.png',
  'hyssop': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/bd49ba9c0f2b9d0933ee79dcd3eb96c8c8ba80ceca5070d3562740cdb59db9d1.png',
  'juniper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/28e6e32d34f207c813d7d89a5d269c4842e3faab8348d001b329c9103956ab07.png',
  'lovage': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/771e5724a33c0558dd77ceadd271c18e2fa4409d37d685b012f81f99673edc74.png',
  'marjoram': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/09372703f0c332978d33f4d2c83db37ea2faad45c9288540f53f123454e242ee.png',
  'mint': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/2e7c6d4303e395daa3e3fcb0f2495b020aaa6f77bb7c8076328e7b6564b18ad5.png',
  'oregano': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/3b9b9a62094bbc0d5559eead58208f87c02326908659aff6fca48a5b78f63a4b.png',
  'parsley': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/64d398dfe147f4fb94f2f2144c19a7e07675a7b9c3807964dd19b920627bbcbd.png',
  'long-pepper': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/5ef52c333943b412f535fa0effc4ce43091a082ea6038d4f96f51d9f6c493fee.png',
  'pomegranate': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/1354c5f77663b76f2b25fa927ae5a8fa4234b170dad4cc61fb9162381d7849ae.png',
  'rosemary': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e908558f605dc578bb1f5fb5fb43f2437e6bee74c58fb77f39c557d9b5c5bc31.png',
  'sage': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/66e14c00677dcfe451d5592af0b73ac6cfc6ad9f7a7fc938e753cbba0ad838e6.png',
  'sweet-flag': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/62c8a291a5154c9942aa41752b05a57520ad51c7e3aabf34c19b3d2733069fea.png',
  'tarragon': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e051549b6206d46e6b9757da9b9bbe81e599a44181452be6afc2f2c5d8cc0d50.png',
  'tejpat': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/56df4ee06cbc8584d50e31a626533ebf52ed27750d95129ac3af05386fd3e88a.png',
  'thyme': 'https://static.prod-images.emergentagent.com/jobs/c6e8a053-5958-4ece-925d-d049a47b0dbc/images/e4ebdb62688d54f6318d2c0f3d73b11a003ca1a555be16426e9bc0b74b578866.png',
};

const getSpiceImage = (imageKey) => {
  return spiceImages[imageKey] || 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400&h=300&fit=crop';
};

export default function SpiceCatalogue() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredSpices = useMemo(() => {
    return spicesData.filter(spice => {
      const matchesSearch = spice.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           spice.botanicalName.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory === 'all' || spice.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchQuery, selectedCategory]);

  const categories = useMemo(() => {
    const cats = [...new Set(spicesData.map(s => s.category))];
    return cats.sort((a, b) => categoryLabels[a].localeCompare(categoryLabels[b]));
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-16 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">Spice Catalogue</span>
          </nav>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Spice Catalogue</h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mb-8">
            India produces a wide range of spices and holds a prominent position in world spice production. 
            Explore our comprehensive catalogue featuring over 50 premium spices sourced from the finest growing regions.
          </p>
          
          {/* Search and Filter */}
          <div className="flex flex-col sm:flex-row gap-4 max-w-2xl">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search spices..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent"
                data-testid="spice-search-input"
              />
            </div>
            <div className="relative">
              <Filter className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full sm:w-auto pl-12 pr-8 py-3 rounded-lg bg-white/10 backdrop-blur border border-white/20 text-white focus:outline-none focus:ring-2 focus:ring-[#F47D20] focus:border-transparent appearance-none cursor-pointer"
                data-testid="spice-category-filter"
              >
                <option value="all" className="bg-[#263776]">All Categories</option>
                {categories.map(cat => (
                  <option key={cat} value={cat} className="bg-[#263776]">
                    {categoryLabels[cat]}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Spices Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="flex items-center justify-between mb-8">
          <p className="text-gray-600">
            Showing <span className="font-semibold text-[#263776]">{filteredSpices.length}</span> spices
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredSpices.map((spice) => (
            <Link
              key={spice.id}
              to={`/products/spices/${spice.id}`}
              className="group bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
              data-testid={`spice-card-${spice.id}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={getSpiceImage(spice.image)}
                  alt={spice.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="absolute top-3 right-3 px-2 py-1 bg-[#F47D20] text-white text-xs font-medium rounded-full">
                  {categoryLabels[spice.category]}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-lg font-semibold text-[#263776] group-hover:text-[#F47D20] transition-colors mb-1">
                  {spice.name}
                </h3>
                <p className="text-sm text-gray-500 italic mb-2">{spice.botanicalName}</p>
                <p className="text-sm text-gray-600 line-clamp-2">
                  {spice.description.substring(0, 100)}...
                </p>
                <div className="mt-3 flex items-center text-[#F47D20] text-sm font-medium">
                  View Details
                  <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredSpices.length === 0 && (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <Search className="w-10 h-10 text-gray-400" />
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">No spices found</h3>
            <p className="text-gray-500">Try adjusting your search or filter criteria</p>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="bg-[#263776] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Premium Quality Spices</h2>
            <p className="text-gray-300 mb-8">
              SPANXPORT sources spices directly from India's premier growing regions, ensuring 
              the highest quality, freshness, and authentic flavor profiles. Our rigorous quality 
              control processes guarantee compliance with international food safety standards.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">50+</div>
                <div className="text-sm text-gray-300">Spice Varieties</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">100%</div>
                <div className="text-sm text-gray-300">Quality Assured</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">50+</div>
                <div className="text-sm text-gray-300">Countries Served</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#F47D20] mb-2">ISO</div>
                <div className="text-sm text-gray-300">Certified</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="bg-gradient-to-r from-[#F47D20] to-[#ff9a4d] rounded-2xl p-8 md:p-12 text-white text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Need a Custom Quote?</h2>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Contact our team for competitive pricing on bulk orders, custom specifications, 
            and tailored packaging solutions for your business needs.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3 bg-white text-[#F47D20] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
            data-testid="spice-catalogue-get-quote-btn"
          >
            Get a Quote
            <ChevronRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </div>
    </div>
  );
}
